import Exception from "components/Exception";
import React from "react";

class ErrorBoundary extends React.Component<{}, { hasError: boolean; }> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false};
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError)
      return <Exception primaryText="Error" othersText={["Something  wrong happened."]} />;
    return this.props.children;
  }
}

export default ErrorBoundary;

